__turbopack_context__.v({
  "close": "newsletterPopup-module-scss-module__oKzphq__close",
  "content": "newsletterPopup-module-scss-module__oKzphq__content",
  "inner": "newsletterPopup-module-scss-module__oKzphq__inner",
  "input": "newsletterPopup-module-scss-module__oKzphq__input",
  "is-hidden": "newsletterPopup-module-scss-module__oKzphq__is-hidden",
  "is-visible": "newsletterPopup-module-scss-module__oKzphq__is-visible",
  "wrapper": "newsletterPopup-module-scss-module__oKzphq__wrapper",
});
